import { render, staticRenderFns } from "./dayNutrisystem.vue?vue&type=template&id=308f4124&scoped=true"
import script from "./dayNutrisystem.vue?vue&type=script&lang=js"
export * from "./dayNutrisystem.vue?vue&type=script&lang=js"
import style0 from "./dayNutrisystem.vue?vue&type=style&index=0&id=308f4124&prod&scoped=true&lang=css"
import style1 from "./dayNutrisystem.vue?vue&type=style&index=1&id=308f4124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f4124",
  null
  
)

export default component.exports